<template>
    <div class="text-left advanced-search">
        <b-tabs class="container">
            <b-tab :title="langAdvancedSearch.posts[locale]" class="text-left" :active="!$route.query.active || $route.query.active==='posts'" @click="setQueryString('posts')">
                <br />
                <p><mark><strong>{{langAdvancedSearch.title[locale]}}</strong></mark></p>
               
                <multiselect v-if="filters[locale].Type" @input="onPostsQueryUpdate" v-model="multiselect.types" :placeholder="langAdvancedSearch.selectTypes[locale]" label="text" track-by="value" :options="filters[locale].Type.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].SubType" @input="onPostsQueryUpdate" v-model="multiselect.subTypes" :placeholder="langAdvancedSearch.selectSubTypes[locale]" label="text" track-by="value" :options="filters[locale].SubType.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].Maker" @input="onPostsQueryUpdate" v-model="multiselect.makers" :placeholder="langAdvancedSearch.selectMakers[locale]" label="text" track-by="value" :options="filters[locale].Maker.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <!--
                <multiselect v-model="multiselect.countries" @input="onPostsQueryUpdate" :placeholder="Select countries" label="text" track-by="value" :options="[{text: 'Finland', value: 'Finland'}]" :multiple="true" :taggable="false"></multiselect>
                <br />
                -->
                <multiselect v-model="multiselect.provinces" @input="onPostsQueryUpdate" :placeholder="langAdvancedSearch.selectProvinces[locale]" label="text" track-by="value" :options="PROVINCES.map(item => {return {value: item, text: item}})" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-model="multiselect.cities" :disabled="multiselect.provinces ? (multiselect.provinces.length === 0):true" @input="onPostsQueryUpdate" :placeholder="langAdvancedSearch.selectCities[locale]" label="text" track-by="value" :options="CITIES.map(item => {if(multiselect.provinces) return multiselect.provinces.map(p => p.value).indexOf(item.Maakunta) > -1 ? {text: item.Kunta, value: item.Kunta} : undefined;}).filter(item => !!item)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].FrameSize" @input="onPostsQueryUpdate" v-model="multiselect.frameSizes" :placeholder="langAdvancedSearch.selectFrameSizes[locale]" label="text" track-by="value" :options="filters[locale].FrameSize.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].Gears" @input="onPostsQueryUpdate" v-model="multiselect.gears" :placeholder="langAdvancedSearch.selectGears[locale]" label="text" track-by="value" :options="filters[locale].Gears.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].TyreType" @input="onPostsQueryUpdate" v-model="multiselect.tyreTypes" :placeholder="langAdvancedSearch.selectTyreTypes[locale]" label="text" track-by="value" :options="filters[locale].TyreType.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].Material" @input="onPostsQueryUpdate" v-model="multiselect.materials" :placeholder="langAdvancedSearch.selectMaterials[locale]" label="text" track-by="value" :options="filters[locale].Material.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].BreakType" @input="onPostsQueryUpdate" v-model="multiselect.breakTypes" :placeholder="langAdvancedSearch.selectBreakTypes[locale]" label="text" track-by="value" :options="filters[locale].BreakType.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].SuspensionType" @input="onPostsQueryUpdate" v-model="multiselect.suspensionTypes" :placeholder="langAdvancedSearch.selectSuspensionTypes[locale]" label="text" track-by="value" :options="filters[locale].SuspensionType.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].Gender" @input="onPostsQueryUpdate" v-model="multiselect.genders" :placeholder="langAdvancedSearch.selectGenders[locale]" label="text" track-by="value" :options="filters[locale].Gender.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].NumOfWheels" @input="onPostsQueryUpdate" v-model="multiselect.numOfWheels" :placeholder="langAdvancedSearch.selectNumOfWheels[locale]" label="text" track-by="value" :options="filters[locale].NumOfWheels.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                
                <multiselect v-if="filters[locale].WheelSize" @input="onPostsQueryUpdate" v-model="multiselect.wheelSizes" :placeholder="langAdvancedSearch.selectWheelSizes[locale]" label="text" track-by="value" :options="filters[locale].NumOfWheels.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].MudGuardType" @input="onPostsQueryUpdate" v-model="multiselect.mudGuardTypes" :placeholder="langAdvancedSearch.selectMudGuardTypes[locale]" label="text" track-by="value" :options="filters[locale].MudGuardType.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].RackType" @input="onPostsQueryUpdate" v-model="multiselect.rackTypes" :placeholder="langAdvancedSearch.selectRackTypes[locale]" label="text" track-by="value" :options="filters[locale].RackType.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <multiselect v-if="filters[locale].BasketType" @input="onPostsQueryUpdate" v-model="multiselect.basketTypes" :placeholder="langAdvancedSearch.selectBasketTypes[locale]" label="text" track-by="value" :options="filters[locale].BasketType.slice(1)" :multiple="true" :taggable="false"></multiselect>
                <br />
                <form-radio-boxes @input="onPostsQueryUpdate" :labelText="langAdvancedSearch.isLockIncluded[locale]" :options="[{value:true, text:langAdvancedSearch.yes[locale]}, {value:false, text:langAdvancedSearch.no[locale]}, {value:undefined, text:langAdvancedSearch.notSure[locale]}]" v-model="multiselect.lockIncluded" :tooltipTitle="langAdvancedSearch.isLockIncludedToolTip[locale]"/>
                <form-radio-boxes @input="onPostsQueryUpdate" :labelText="langAdvancedSearch.isFrontLightIncluded[locale]" :options="[{value:true, text:langAdvancedSearch.yes[locale]}, {value:false, text:langAdvancedSearch.no[locale]}, {value:undefined, text:langAdvancedSearch.notSure[locale]}]" v-model="multiselect.frontLightIncluded" :tooltipTitle="langAdvancedSearch.isFrontLightIncludedToolTip[locale]"/>
                <form-radio-boxes @input="onPostsQueryUpdate" :labelText="langAdvancedSearch.isRareLightIncluded[locale]" :options="[{value:true, text:langAdvancedSearch.yes[locale]}, {value:false, text:langAdvancedSearch.no[locale]}, {value:undefined, text:langAdvancedSearch.notSure[locale]}]" v-model="multiselect.rareLightIncluded" :tooltipTitle="langAdvancedSearch.isRareLightIncludedToolTip[locale]"/>
                <form-radio-boxes @input="onPostsQueryUpdate" :labelText="langAdvancedSearch.legStandExist[locale]" :options="[{value:true, text:langAdvancedSearch.yes[locale]}, {value:false, text:langAdvancedSearch.no[locale]}, {value:undefined, text:langAdvancedSearch.notSure[locale]}]" v-model="multiselect.legStandExists" :tooltipTitle="langAdvancedSearch.legStandExistToolTip[locale]"/>

                <div class="row">
                    <div class="col">
                        <form-input @input="onPostsQueryUpdate" :labelText="langAdvancedSearch.priceStart[locale]" :placeholder="langAdvancedSearch.priceStartPlaceholder[locale]" :inputType="'number'" :min="0" v-model="multiselect.minPrice"/>
                    </div>
                    <div class="col">
                        <form-input  @input="onPostsQueryUpdate" :labelText="langAdvancedSearch.priceEnd[locale]" :placeholder="langAdvancedSearch.priceEndPlaceholder[locale]" :inputType="'number'" :min="0" v-model="multiselect.maxPrice"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-input @input="onPostsQueryUpdate" :labelText="langAdvancedSearch.textSearch[locale]" :placeholder="langAdvancedSearch.textSearchPlaceholder[locale]" :inputType="'text'" v-model="multiselect.text"/>
                    </div>
                </div>
                <!-- condition here -->
                <form-filter-condition :labelText="langQuickSearch.selectACondition[locale]" v-model="multiselect.condition"  @change="onPostsQueryUpdate" :options="filters[locale].selectCondtionOptions" :allowedValues="filters[locale].selectCondtionOptions.map(item => (item.value))" :tooltipTitle="langQuickSearch.selectAConditionToolTip[locale]"/>
                <br />
                <nettipyora-button :text="`${langAdvancedSearch.search[locale]} ${+searchPostCount>-1?searchPostCount:''}`" :loading="searchingPostCount" :clickHandler="searchPostBtnClicked" :className="'btn-info'"  />
                <br />
                <br />
            </b-tab>
            <b-tab title="Seller" class="text-left" :active="$route.query.active==='seller'" @click="setQueryString('seller')">
                <br />
                <p><mark><strong>{{langAdvancedSearch.otherTitle[locale]}}</strong></mark></p>
                <form-input :labelText="langAdvancedSearch.nameOfTheSeller[locale]" :placeholder="langAdvancedSearch.nameOfTheSeller[locale]" :inputType="'text'" v-model="query.user.searchText"/>
                <!--
                <form-select :labelText="'Select a country'" v-model="query.user.country" :options="[{text: 'Select a Country', value: undefined}, 'Finland']" :allowedValues="['Finland']" :tooltipTitle="'Country is required'"/>
                -->
                <form-select :labelText="langAdvancedSearch.selectAProvince[locale]" v-model="query.user.province" :options="[{text: langAdvancedSearch.selectAProvince[locale], value: undefined}, 'Pohjois-Pohjanmaa']" :allowedValues="['Pohjois-Pohjanmaa']" :tooltipTitle="langAdvancedSearch.selectAProvinceToolTip[locale]"/>
                <form-select :labelText="langAdvancedSearch.selectACity[locale]" v-model="query.user.city" :options="[{text: langAdvancedSearch.selectACity[locale], value: undefined}, 'Oulu']" :allowedValues="['Oulu']" :tooltipTitle="langAdvancedSearch.selectACityToolTip[locale]"/>
                <br />
                <nettipyora-button :text="`${langAdvancedSearch.search[locale]} ${+searchUserCount>-1?searchUserCount:''}`" :loading="searchingUserCount || usersLoading" :clickHandler="searchUserBtnClicked" :className="'btn-info'"  />
                <br />
                <br />
                <div class="container" v-if="usersLoading">
                    <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
                </div>
                <div class="container" v-else-if="statusOk">
                    <div v-if="users.length === 0">
                        <strong>{{langAdvancedSearch.userNotFound[locale]}}</strong>
                    </div>
                    <div v-else class="user" v-for="user in users" :key="user._id">
                        <router-link :to="user._id === authenticatedUserID ? 'account':('/user/'+user._id)">
                            <div v-if="!!user.imageURI" :style="`margin: 1px; margin-left: 5px; width: 32px; height: 30px; border-radius: 20px; vertical-align: top; background-image:url(${user.imageURI}); display: inline-block; background-position: center; background-repeat: no-repeat; background-size: contain`"/>
                            <font-awesome-icon v-else icon="image" size="2x" style="margin-left: 5px; vertical-align: top"/>
                            <strong style="margin-left: 1em; margin-right: 1em; vertical-align: middle">{{user.name}}</strong> <b-badge style="margin-right: 1em; vertical-align: middle" v-if="user.role === 'store'"> {{user.role}} </b-badge>
                            <div class="post-location-owner text-muted" style="vertical-align: middle">
                                <small class="post-location">{{user.country}}</small>
                                <small> > </small>
                                <small class="post-location">{{user.province}}</small>
                                <small> > </small>
                                <small class="post-location">{{user.city}}</small>
                            </div>
                        </router-link>
                    </div>
                    <nettipyora-button v-if="usersLoadMore" :text="`${langAdvancedSearch.loadMore[locale]} ${usersLoadMore>0?('('+usersLoadMore+')'):''}`" :loading="usersLoadingMore" :clickHandler="loadMoreUserBtnClicked" :className="'btn-outline-info'"  />
                    <br />
                </div>
                <div v-else-if="message">
                    <b-alert show variant="danger">{{message}}</b-alert>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
/* eslint-disable no-console */
//import { FETCH_AUTHENTICATED_USER } from "@/store/constants";
import Multiselect from 'vue-multiselect';
import NettipyoraButton from "@/components/NettipyoraButton.vue";
//import FormCheckBoxes from '@/components/FormCheckBoxes';
import FormRadioBoxes from '@/components/FormRadioBoxes';
import FormSelect from '@/components/FormSelect';
import FormInput from '@/components/FormInput';
import { mapState } from 'vuex';
//import Post from "@/components/Post";
import debounce from '@/plugins/debaunce';
import langAdvancedSearch from '@/store/lang/advancedSearch';
import FormFilterCondition from '@/components/FormFilterCondition';
import langQuickSearch from '@/store/lang/quickSearch';
import { CITIES, PROVINCES } from '@/store/constant';

export default {
    name: "advanced-search",
    components: {
        Multiselect, NettipyoraButton, FormRadioBoxes, FormSelect, FormInput, FormFilterCondition
    },
    data() {
        return {
            CITIES, PROVINCES,
            langAdvancedSearch, langQuickSearch,
            multiselect: {},
            query: {
                user: {
                    searchText: undefined,
                    province: null,
                    city: null
                }
            }
        };
    },
    computed: {
        ...mapState({
            locale: state => state.locale,
            filters: state => state.filters,
            authenticatedUserID: state => state.authenticatedUserID,
            searchingPostCount: state => state.AdvancedSearch.searchingPostCount,
            searchPostCount: state => state.AdvancedSearch.searchPostCount,
            searchingUserCount: state => state.AdvancedSearch.searchingUserCount,
            searchUserCount: state => state.AdvancedSearch.searchUserCount,
            usersLoading: state => state.AdvancedSearch.usersLoading,
            users: state => state.AdvancedSearch.users,
            usersLoadMore: state => state.AdvancedSearch.usersLoadMore,
            usersLoadingMore: state => state.AdvancedSearch.usersLoadingMore,
            statusOk: state => state.AdvancedSearch.statusOk, 
            message: state => state.AdvancedSearch.message
        })
    },
    mounted () {
        this.$watch('$data.query.user', debounce(this.onUserQueryUpdate, 500), { deep: true });
        this.multiselect = this.$route.query.query ? JSON.parse(this.$route.query.query) : {};
        //for ui
        this.multiselect.condition = this.multiselect.condition ? this.multiselect.condition : null;
        //console.log("mounted query", this.$route.query.query, this.multiselect);
    },
    methods: {
        getQueryString() {
            const params =  JSON.parse(JSON.stringify(this.multiselect));
            const query = {};
            for(let key in params) {
                if(Array.isArray(params[key])) {
                    //const val = data[key] ? data[key].map(item => {return item.value}) : [];
                    const val = [];
                    params[key].forEach(item => {
                        if(item.value) val.push(item.value);
                    });
                    //query[key] = val.length ? val : undefined;
                    if(val.join(',')) query[key] = val.join(',');
                } else {
                    if(typeof params[key] === 'string') {
                        params[key] = params[key].trim();
                        if(params[key]) query[key] = params[key];
                    } else query[key] = params[key];
                }
            }
            return query;
        },
        jsonToQueryString(json) {
            json.page = 1;
            return  Object.keys(json).map(function(key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
        },
        setQueryString(name) {
            const data = {query: {active: name}};
            if(this.$route.query.query) data.query.query = this.$route.query.query;
            this.$router.replace(data);
        },
        searchPostBtnClicked() {
            //console.log("query", this.multiselect);
            this.$router.replace({query: {query: JSON.stringify(this.multiselect)}})
            this.$router.push({path: '/advanced-search/result', query: {query: this.jsonToQueryString(this.getQueryString())}});
        },
        searchUserBtnClicked() {
            this.$store.dispatch('ADVANCED_SEARCH_FETCH_USERS', JSON.parse(JSON.stringify(this.query.user)));
        },
        loadMoreUserBtnClicked() {
            const query = JSON.parse(JSON.stringify(this.query.user));
            query.lastID = this.users[this.users.length-1]._id;
            this.$store.dispatch('ADVANCED_SEARCH_FETCH_USERS', query);
        },
        onUserQueryUpdate() {
            this.$store.dispatch('ADVANCED_SEARCH_FETCH_USERS_COUNT', JSON.parse(JSON.stringify(this.query.user)));
        },
        onPostsQueryUpdate: debounce(function() {
            const query = this.getQueryString();
            this.$store.dispatch('ADVANCED_SEARCH_FETCH_POSTS_COUNT', query);
        }, 500)
    }
};
</script>

<style lang="scss">
.advanced-search {
    margin-top: 2em;

    span.multiselect__placeholder {
        color: inherit;
        font-weight: bold;
    }

    .user {
        margin: 1em;
        border: 1px solid lightgray;
        border-radius: 5px;
        .post-location-owner {
            display: inline-block;
        }
    }
    .user:hover {
        border: 1px solid gray;
    }
}
</style>
